import { render, staticRenderFns } from "./fonts.vue?vue&type=template&id=2c26399a"
import script from "./fonts.vue?vue&type=script&lang=js"
export * from "./fonts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports